
export default class {
    prev() {
        this.year = this.year * 1 - 1
    }
    next() {
        this.year = this.year * 1 + 1
    }
    selectSeason(i) {
        let season = i + 1
        var month = new Date().getMonth() + 1;//getMonth返回0-11
        var jidu = undefined
        //下面是几个if
        if(month >=1 && month <=3){
            jidu = 1;
        }else if(month >=4 && month <=6){
            jidu = 2;
        }else if(month >=7 && month <=9){
            jidu = 3;
        }else{
            jidu = 4;
        }
        if(this.year== new Date().getFullYear()&& season<=jidu){
            this.showSeason = false
            this.currenttime = `${this.year}年${season}季度`
        }else if(this.year< new Date().getFullYear()){
            this.showSeason = false
            this.currenttime = `${this.year}年${season}季度`
        }else {
            this.$message({
                message: '请选择正确日期！',
                type: 'warning'
            })

        }

    }
}
